module.exports = __webpack_public_path__ + "img/7.2a004c66.png";